export default __webpack_public_path__ + "static/stream-thumbnail-dcff04e561c9f3880c3181c421d1df5f.png";